import axiosPrivate from "@services/axiosPrivate"
import { FACEBOOK_ADS_URL } from "src/constants"

export const createFacebookAd = async (adAccountId, data) => {
  return await axiosPrivate.post(`act_${adAccountId}/${FACEBOOK_ADS_URL}`, data)
}
